import { type Common } from '../common.js';

export class API {
  common: Common;
  readonly baseEndpoint = '/copilot/jobs';

  constructor(common: Common) {
    this.common = common;
  }

  async isCopilotEnabledForJob(jobId: number): Promise<boolean> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${jobId}/enabled`);
    const { copilotEnabled } = await this.common.getJSON(url);
    return copilotEnabled;
  }
}
